import { Injectable } from '@angular/core';
import { Command } from 'flux-core';
import { AbstractDiagramChangeCommand } from './abstract-diagram-change-command.cmd';
import { DiagramChangeService } from '../../../base/diagram/diagram-change.svc';
import { ShapeModel } from '../../../base/shape/model/shape.mdl';

/**
 * SetConnectorBarType
 * Sets the connectorBarType property for one or more connector bar shapes.
 */
@Injectable()
@Command()
export class SetConnectorBarType extends AbstractDiagramChangeCommand {
    /**
     * Command input data format
     */
    public data: {
        changes: {
            [shapeId: string]: string,
        },
    };

    constructor(ds: DiagramChangeService) {
        super(ds);
    }

    /**
     * Prepare command data by modifying the change model.
     */
    public prepareData() {
        for (const shapeId in this.data.changes) {
            const connectorBarType = this.data.changes[shapeId];
            const shape = this.changeModel.shapes[shapeId] as ShapeModel;
            
            // Only update if the shape exists and is a connector bar
            if (shape && (shape.defId === 'creately.basic.connectorbar' || shape.defId === 'creately.basic.org-connectorbar')) {
                shape.connectorBarType = connectorBarType;
            }
        }
    }
}

Object.defineProperty(SetConnectorBarType, 'name', {
    value: 'SetConnectorBarType',
});